import React, {useContext, useEffect, useRef, useState} from 'react';
import {CustomSelect} from 'components/CustomSelect'

import {Col, Form} from "react-bootstrap";
import {EntityAccountsContext} from "./context";
import {useLocation} from "react-router";
import {showAsterisk} from "../../utils/FormatUtils";
import {getSessionAttribute, setSessionAttribute} from "../../utils/SessionUtils";
import {SELECTED_ACCOUNT, SELECTED_ENTITY, ACCOUNTS_OPTIONS,ACCOUNTS_OPTIONS_NO_SWAP, LEGAL_ENTITY} from "../../utils/Constants";
import AuthenticationService from "../../service/AuthenticationService";

const EntityAccountsComponent = (props) => {
    const {clearAccountDetails, setInitEntityAccountsOptions, entityAccountsOptions,entityAccountsOptionsNoSwap, accountsOptions,accountsOptionsNoSwap, entityAccounts,entityAccountsNoSwap, setManagerDetails, setAccountDetails, getAccountsForSelectedEntity} = useContext(EntityAccountsContext);
    const [selectedOption,setSelectedOption] = useState({})
    // addAllInEntity  'ALL' is the first entity selection.
    const {accountOptional, ssaEntityWidthFull,hideSwapLob, onAccountChange,addAllInEntity} = props
    const location  = useLocation();
    const pathname = location.pathname;



    const handleAccountChange = (e) => {

        const accountId = e.target.value;
        let  accountToSelect = null
        if (hideSwapLob) {
            accountToSelect = accountsOptionsNoSwap.find(account => account.accountId.toString() === accountId);
        } else {
            accountToSelect = accountsOptions.find(account => account.accountId.toString() === accountId);
        }
        if(accountToSelect) {
            setAccountDetails(accountToSelect.accountId, accountToSelect.name, accountToSelect.accountCode, hideSwapLob, accountToSelect?.holidayException);
            setSessionAttribute(LEGAL_ENTITY,accountToSelect.legalEntity)
            setSessionAttribute(SELECTED_ACCOUNT, null);
            setSessionAttribute(SELECTED_ACCOUNT, accountToSelect);
            if(!AuthenticationService.isInternalUser()){ // Currently all external users have Wire Submission unless not configured in Client Master
                onAccountChange()
            }
        }
        else{
            let firstAccountForLegalEntity = getAccountsForSelectedEntity(getSessionAttribute(SELECTED_ENTITY).managerId,hideSwapLob)[0]
            setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null, holidayException: false});
            setSessionAttribute(LEGAL_ENTITY, firstAccountForLegalEntity?.legalEntity)
            setAccountDetails('','',null, hideSwapLob, false);
        }
    }
    useEffect(() => {
        if (hideSwapLob) {
            getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? setInitEntityAccountsOptions(hideSwapLob);
        }
        else
        {
            getSessionAttribute(ACCOUNTS_OPTIONS) ?? setInitEntityAccountsOptions(hideSwapLob);
        }
    }, []);

    const  getOptions = (hideSwapLob) => {
        let eaOptions
        if (hideSwapLob) {
            eaOptions = entityAccountsOptionsNoSwap
        } else {
            eaOptions = entityAccountsOptions
        }
        const options = []
        if (addAllInEntity) {
            let option = {}
            option['value'] = -1
            option['label'] = 'ALL'
            options.push(option)
        }
        if (eaOptions) {
            eaOptions.map(e=>{
                let option = {}
                option['value'] = e.managerId
                option['label'] = e.shortName+'-'+e.longName
                options.push(option)
            })
        }
        return options;
    }

    useEffect(() => {
        if (!hideSwapLob) {
            if (entityAccounts.disableAccounts)
                clearAccountDetails(hideSwapLob);
        }
    }, [entityAccounts.disableAccounts]);

    useEffect(() => {
        if (hideSwapLob) {
            if (entityAccountsNoSwap.disableAccounts)
                clearAccountDetails(hideSwapLob);

        }
    }, [entityAccountsNoSwap.disableAccounts]);

    const changeSelectedOptions= (hideSwapLob)=>{
        let selectedEntity = null
        let selectManagerId = ""
        if (hideSwapLob) {
            selectManagerId = entityAccountsNoSwap.managerId
        } else {
            selectManagerId = entityAccounts.managerId
        }

        const entityOptions = getOptions(hideSwapLob);
        // handle all or empty
        if (selectManagerId === -1 || selectManagerId === '') {
            // select the first position
            if (entityOptions?.length>0) {
                setSelectedOption(entityOptions[0])
            } else{
                setSelectedOption({})
            }
        } else {
            // regular
            selectedEntity = entityOptions.filter(e=>e.value===Number(selectManagerId))
            if(selectedEntity.length>0)
            {
                setSelectedOption(selectedEntity[0]);
            }
            else{
                setSelectedOption({})
            }
        }
    }


    useEffect(()=>{
        if (hideSwapLob === false) {
            changeSelectedOptions(false)
        }
    },[entityAccounts.managerId, entityAccounts])

    useEffect(()=>{
        if (hideSwapLob === true) {
            changeSelectedOptions(true)
        }
    },[entityAccountsNoSwap.managerId, entityAccountsNoSwap])


    const entityFilterOption = (option, rawInput) => {
        const input = (rawInput ?? '').toLowerCase().trim();
        return !input || (option.label ?? '').toLowerCase().includes(input);
    }

    const handleChangeAutocomplete = (e)=>{
        setManagerDetails(e.value, e.label, hideSwapLob);

        let selectedEntity = {};
        selectedEntity['managerId']=e.value;
        selectedEntity['managerName']=e.label;
        setSessionAttribute(SELECTED_ENTITY,selectedEntity);
        let firstAccountForLegalEntity = getAccountsForSelectedEntity(selectedEntity['managerId'],hideSwapLob)?.[0]
        setSessionAttribute(LEGAL_ENTITY, firstAccountForLegalEntity?.legalEntity)
        setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null, holidayException: false});
    }

    return(<>
        <Col md={'12'} sm={ssaEntityWidthFull?'12':'6'} >
            <Form.Group controlId="formGridEntity"   id={(hideSwapLob?(!!entityAccountsNoSwap.formErrors.search.entity? 'td-select-error':''):(!!entityAccounts.formErrors.search.entity? 'td-select-error':''))}>
                <Form.Label className="filter-input-label">Entity *</Form.Label>
                    <CustomSelect
                        isDisabled={props.isReadOnly ?? false}
                        placeholder={'Select'}
                        options={getOptions(hideSwapLob)}
                        filterOption={entityFilterOption}
                        value={Object.keys(selectedOption).length > 0?selectedOption:null}
                                   onChange={handleChangeAutocomplete}
                        isValid={hideSwapLob?(!entityAccountsNoSwap.formErrors.search.entity):(!entityAccounts.formErrors.search.entity)}
                        className={hideSwapLob?(!entityAccountsNoSwap.formErrors.search.entity?'is-invalid invalid':''):(!entityAccounts.formErrors.search.entity?'is-invalid invalid':'')}
                    />

                {hideSwapLob?(!!entityAccountsNoSwap.formErrors.search.entity):(!!entityAccounts.formErrors.search.entity) &&
                    <b className={'error-text'}><i className="bi bi-exclamation-circle"></i>{hideSwapLob?(entityAccountsNoSwap.formErrors.search.entity):(entityAccounts.formErrors.search.entity)}</b>
                }
            </Form.Group>
        </Col>
        {(hideSwapLob?entityAccountsNoSwap.showAccounts:entityAccounts.showAccounts) &&
            <Col md={'12'} sm={'6'}>
                <Form.Group controlId="formGridAccount" className={'td-select'} id={(hideSwapLob?(!!entityAccountsNoSwap.formErrors.search.account?!accountOptional?'td-select-error':'':''):(!!entityAccounts.formErrors.search.account?!accountOptional?'td-select-error':'':''))}>
                    <Form.Label className="filter-input-label" >Account {showAsterisk(pathname) ? '*' : '' }</Form.Label>
                    <Form.Control as="select" name='accounts' value={hideSwapLob?entityAccountsNoSwap.accountId:entityAccounts.accountId} onChange={handleAccountChange} disabled={hideSwapLob?entityAccountsNoSwap.disableAccounts:entityAccounts.disableAccounts}
                                  isInvalid={!!entityAccounts.formErrors.search.account && !accountOptional} >
                        <option value={''}>Select </option>
                        {hideSwapLob?(accountsOptionsNoSwap && accountsOptionsNoSwap.map((account) => <option key={account.accountId} value={account.accountId}>{account.accountCode}-{account.name} </option>)):(accountsOptions &&
                            accountsOptions.map((account) => <option key={account.accountId} value={account.accountId}>{account.accountCode}-{account.name} </option>))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type={'invalid'} >
                        <b><i className="bi bi-exclamation-circle"></i>{hideSwapLob?entityAccountsNoSwap.formErrors.search.account:entityAccounts.formErrors.search.account}</b>
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        }

    </>);

};

export {EntityAccountsComponent};

EntityAccountsComponent.defaultProps = {
    accountOptional: false,
    ssaEntityWidthFull: false,
    hideSwapLob: false,
    addAllInEntity: false,
    onAccountChange: () => {}
}